import React from 'react';
import { Form, Input } from 'antd';



const { TextArea } = Input;

export default function PodatZayavlenieNaOtmenuRegistratsiiPariFederatsiiVEtomRegOt(props) {
    const { object, form } = props;

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    paraID: object.ID
                }}
            >
                <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"paraID"}
                    label={"Пара"}
                    rules={[{ required: true, message: 'Укажите пару!' }]}
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item
                    name={"prichinaTekst"}
                    label={"Причина"}
                    rules={[{ required: false, message: 'Укажите причину!' }]}
                >
                    <TextArea rows={2} />
                </Form.Item>
            </Form>
        </>
    );
}
